/* eslint-disable @typescript-eslint/no-unused-vars */
import { IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'
import { cn } from '../../Utils/component'
import { SubscriptionType } from '../../types/firm/Subscription'
import { LikeFirmButton } from '../common/like/LikeFirmButton'
import { Info, Teaser as TeaserUI } from '../ui'
import { formatNbOffers } from './format'
import HeaderMedia from './headerMedia'

export type TeaserProps = {
  id: number
  uuid?: string
  city?: string
  name: string
  header: string | IGatsbyImageData | null
  logo: string | null
  totalEmployees: string
  url: string
  nbTotalOffers: number
  nbOffices: number | null
  color?: string
  subscriptionType?: SubscriptionType
  likesCount?: number
}

export const FirmTeaser: React.FC<TeaserProps> = ({
  id,
  uuid,
  city = undefined,
  header,
  logo,
  name,
  totalEmployees,
  url,
  nbTotalOffers,
  nbOffices,
  subscriptionType = undefined,
  color = undefined,
  likesCount = undefined,
}) => {
  const nbTotalOffersToDisplay = nbTotalOffers ?? 0
  const logoToDisplay = logo || '../../../Logo_V_Lamacompta.jpg'

  const isNotClient = !subscriptionType

  return (
    <div className="relative w-full h-full">
      {id && <LikeFirmButton
        firmId={id}
        className="absolute -top-4 -right-5 z-10"
      />}
      <TeaserUI
        header={<HeaderMedia url={header} name={name} colorCareerSite={color} />}
        logo={
          <img
            src={logoToDisplay}
            alt={`logo ${name}`}
            className="object-contain w-full h-full"
          />
        }
        url={url}
        type="firm"
      >
        <div className="flex items-center mt-6 md:mt-1">
          <div className="text-lg font-bold text-primary">{name}</div>
        </div>

        <div className="flex flex-col flex-wrap gap-4 pt-1 pb-3 text-night">
          <Info value={totalEmployees} icon="lama" color="night" size="sm" />
          <div className="flex flex-row items-center">
            <Info value={city} icon="pin" color="night" size="sm" />
            {nbOffices && nbOffices > 0 && (
              <div className="self-center mt-1 h-5 text-sm">+ {nbOffices}</div>
            )}
          </div>
        </div>

        <div
          className={cn('text-sm', isNotClient ? 'text-white' : 'text-primary')}
        >
          {formatNbOffers(nbTotalOffersToDisplay)}
        </div>
      </TeaserUI>
    </div>
  )
}
